<template>
  <div class="container">
    <div class="content-font2">
      <h1 align="center">预付款协议</h1>
      <P>
        鉴于您(也称“乘客用户")已与深圳万顺叫车云信息技术有限公司(以下简称“我司”)在线签署《万顺叫车软件许可及服务协议》(以下简称“用户服务协议”)，根据平台规则，您在接受服务过程中存在需要预先支付预付款的情形，特订立本预付款协议(以下简称“本协议”)，作为用户服务协议的补充条款。</P>
      <P><STRONG>在您使用相关服务前，请您认真阅读本协议(尤其是粗体标注部分)，未成年人应在法定监护人陪同下阅读。您点击同意将视为您对本协议的接受，并同意受本协议各项约定和条款的约束。您对本协议的接受将使您可以继续使用相关服务，而您对本协议的拒绝将视为您拒绝使用相关服务。</STRONG>
      </P>
      <P><STRONG>您理解并同意：</STRONG></P>
      <P>
        1、根据您选择/预约的出行需求，我司将按照平台相关计价规则就您的本次出行费用进行预估，而您需要向平台缴纳该预估的行程费用作为后续您使用相关服务的履约保证金及使用服务的预付款(“预付款”)，并在使用服务后冲抵相应车款。您确认您的行程、并支付预付款的行为，将视为您就本次出行需求正式发出订单。若您选择不支付预付款，您将无法发出出行订单，而您也将无法使用我司平台内司机提供的线下服务。</P>
      <P>
        2、您充分理解并同意，您就本次出行所支付的该笔款项应当且仅应被认定为该笔订单的预付款，而不会在任何方面被认定为您的一项充值行为。与之相应的，您所支付的预付款将不会以任何方式显示到您在万顺叫车的账户余额中。</P>
      <P>
        3、您支付预付款、生成订单后，您的订单将会进入系统，并生成相应的订单数据。该订单被接受后，您可使用相应的线下服务。您就本次出行服务需要支付的行程费用或按照平台规则扣除的费用以实际发生为准，并优先从该笔预付款中扣除，并根据多退少补原则就本次出行的实际行程费用与您进行结算。您在此同意并确认，平台有权将您就本次出行已经支付的预付款用于抵扣本次出行的实际行程费用，且您在此同意此抵扣。</P>
      <P>
        4、若预付款超出您本次出行的实际行程费用的，平台将在行程完成后根据您的实际支付方式将抵扣完成后的剩余款项原路径返还给您，退款时限届时以银行及第三方支付机构的工作时限为准，通常情形下不超过七(7)个工作日而若预付款不足以全部抵扣您本次出行的实际行程费用的，您还应当就不足部分继续通过平台进行支付。在您完成支付前，您将无法继续在平台中使用线下出行服务。</P>
      <P>
        5、在您支付预付款、生成订单后，非因您的原因导致您未在平台内使用线下出行服务(原因包括但不限于您的订单未被接受、不可抗力事件发生、以及其他原因等)，平台将根据您的实际支付方式将您已经支付的预付款原路径全额返还给您;若在生成订单后您单方面取消订单、且被认定为有责取消时，平台将会根据相关平台规则计算相应费用，并在扣除该等费用后将剩余款项原路径全额返还给您。退款时限届时以银行及第三方支付机构的工作时限为准，通常情形下不超过七(7)个工作日。</P>
      <P>6、本协议适用中华人民共和国法律。如果双方发生纠纷，应本着友好的原则协商解决。</P>
      <P>7、若本协议中的某些条款因故无法适用，则本协议的其他条款继续适用且无法适用的条款将会被修改，以便其能够依法适用。</P>
      <P>8、与本服务相关的用户协议、服务协议、隐私政策等文件将同时构成本协议的一部分，若本协议的条款与上述相关文件的条款冲突的，则以本协议为准。</P>
      <P>9、本协议条款的最终解释权归万顺叫车所有。</P>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isMini: true
      };
    },
    created() {
    },
    mounted() {
    },
    methods: {},
  };
</script>
<style scoped lang="less">
  .content-font2 {
    p {
      text-indent: 2rem;
    }
  }
</style>

